import { validate, validateByType, positionWindowAtFormElement, removeAllErrors } from '../../utils/form-validation-utils';
import { createAccount } from './account-api';
import { checkLoginStatus } from './login';

const addCreateAccountCallbacks = (callbacks) => {
  window.onSubmitCallbacks = callbacks;
};
const removereateAccountCallbacks = () => {
  window.onSubmitCallbacks = null;
};

const passwordMatch = (passIpt, passConfirmIpt) => {
  if (passIpt.value === passConfirmIpt.value) {
    return true;
  }
  return false;
};

const passwordStrength = (passIpt, passConfirmIpt) => {
  if (passIpt.value === '' && passConfirmIpt.value === '') {
    return true; // ignore
  }
  if (validateByType('password', passIpt.value) && validateByType('password', passConfirmIpt.value)) {
    return true;
  }
  return false;
};
const resetCreateAccountForm = (options) => {
  const { form } = options;
  const errorMsg = form.querySelector('.password-mismatch-error-message');
  const existingErrorMsg = form.querySelector('.existing-account-error-message');
  const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
  const passwordStrengthErrorMsg = form.querySelector('.password-strength-error-message');
  const username = form.querySelector('[name="acctUsername"]');
  const passIpt = form.querySelector('[name="acctPassword"]');
  const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
  username.value = '';
  passIpt.value = '';
  passConfirmIpt.value = '';
  form.querySelector('[name="offer-opt-in"]').checked = true;
  // Remove errors
  errorMsg.classList.add('hide');
  existingErrorMsg.classList.add('hide');
  accountCreationErrorMsg.classList.add('hide');
  passwordStrengthErrorMsg.classList.add('hide');
  removeAllErrors(form);
};


const init = (options) => {
  const { form, disableScroll } = options;
  const errorMsg = form.querySelector('.password-mismatch-error-message');
  const existingErrorMsg = form.querySelector('.existing-account-error-message');
  const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
  const passwordStrengthErrorMsg = form.querySelector('.password-strength-error-message');
  const username = form.querySelector('[name="acctUsername"]');
  const passIpt = form.querySelector('[name="acctPassword"]');
  const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
  const submitBtn = form.querySelector('.o-form__submit');

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    const { onSubmitCallbacks } = window;
    passIpt.parentNode.classList.remove('ValidationFail');
    passConfirmIpt.parentNode.classList.remove('ValidationFail');
    errorMsg.classList.add('hide');
    existingErrorMsg.classList.add('hide');
    accountCreationErrorMsg.classList.add('hide');
    passwordStrengthErrorMsg.classList.add('hide');
    if (validate(form) && passwordMatch(passIpt, passConfirmIpt)) {
      // Unhecked/checked opt-in map to 0/1
      let optInVal = 0;
      if (form.querySelectorAll('[name="offer-opt-in"]:checked').length === 1) {
        optInVal = 1;
      }
      createAccount(
        {
          username: username.value,
          password: passIpt.value,
          'marketing-opt-in': optInVal,
          'microsite-name': window.micrositeName,
        },
        {
          onSuccess: (data) => {
            if (data['user-id'] === 0 || data['user-id'] === '0') {
              existingErrorMsg.classList.remove('hide');
            } else if (data['user-id'] === -1) {
              accountCreationErrorMsg.classList.remove('hide');
            } else {
              window.isAuthenticated = true;
              window.userId = data['user-id'];
              checkLoginStatus(() => {
                if (onSubmitCallbacks) {
                  onSubmitCallbacks.onLoginSuccess();
                } else {
                  window.location = window.myAccountUrl;
                }
              });
            }
          },
          onError: () => {
            errorMsg.classList.remove('hide');
            if (onSubmitCallbacks) {
              onSubmitCallbacks.onLoginFail();
            }
          },
        },
      );
    } else if (!passwordMatch(passIpt, passConfirmIpt)) {
      passIpt.parentNode.classList.add('ValidationFail');
      passConfirmIpt.parentNode.classList.add('ValidationFail');
      errorMsg.classList.remove('hide');
      // Don't run if in modal
      // console.log(`create-account.js, disableScroll: ${disableScroll}`);
      if (!disableScroll) {
        positionWindowAtFormElement({
          element: form.parentNode,
          offset: -75,
        });
      }
    } else {
      // Don't run if in modal
      if (!disableScroll) { /* eslint-disable-line no-lonely-if */
        positionWindowAtFormElement({
          element: form.parentNode,
          offset: -75,
        });
      }
      if (!passwordStrength(passIpt, passConfirmIpt)) {
        passwordStrengthErrorMsg.classList.remove('hide');
      }
    }
  });
};

export {
  addCreateAccountCallbacks,
  removereateAccountCallbacks,
  init,
  resetCreateAccountForm,
};
/* eslint-enable no-console */
